import { GET_VERSIONS } from '../actions';

export default function(state = {}, action) {
    return state;
}